/* eslint-disable no-restricted-imports */
import React, { useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useCouponContext } from "./CouponDataContext";

export function CouponActivateDialog({
  history,
  id,
  active_value,
  show,
  onHide,
}) {
  const context = useCouponContext();
  // Coupon Context

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const activateCoupon = async () => {
    const activateUrl = "api/discounts/activate/";

    //edit coupon post
    const result = await axios.patch(activateUrl + id);
    if (result.data === "success") {
      //setEditSuccessOpen(true);
      //console.log("activated");
      context.setRefetch(true);
      setTimeout(() => {
        history.push("/coupons/coupon-list");
      }, 1000);
    } else {
      //setEditErrorOpen(true);
    }
    // closing delete modal
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* {isLoading && <ModalProgressBar variant="query" />} */}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Coupon Activate
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure to activate this coupon?</span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={activateCoupon}
            className="btn btn-delete btn-elevate"
          >
            Activate
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
